export default ({movement}) => (
	<>
		<h2>{movement.name}</h2>
		<p className="excerpt">{movement.descriptionShort}</p>
		<div className="description" dangerouslySetInnerHTML={{ __html: movement.description}} />
	</>
)
